import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TimeslotInterface } from '@sport-activities/sdk';
import { EMPTY, Subscription } from 'rxjs';
import { concatMap, expand, reduce } from 'rxjs/operators';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';

import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { ModalComponent } from '~/component/modal/modal.component';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
import { TitleService } from '~/core/services/title/title.service';
import { ActivitySelectionService } from '~/organizer/activity-planning/services/activity-selection.service';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

@Component({
  selector: 'app-organizer-planning-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['planning.component.scss'],
})
export class OrganizerPlanningPagePlanningComponent
  implements OnDestroy, OnInit, AfterViewInit
{
  @ViewChild('welcomeModal')
  public welcomeModal: ModalComponent;
  private readonly subscriptions$ = new Subscription();
  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;
  private isMobileDevice: boolean;
  private timeslotsSubscription$: Subscription;
  public timeslots: TimeslotInterface[] = [];

  constructor(
    private readonly activitySelectionService: ActivitySelectionService,
    private readonly organizerSharedOrganizationService: OrganizerSharedOrganizationService,
    private readonly organizerSharedActivityService: OrganizerSharedActivityService,
    private readonly route: ActivatedRoute,
    private readonly titleService: TitleService,
    private readonly matchMediaService: MatchMediaService
  ) {}

  public ngAfterViewInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      if (params.has('newOrganization')) {
        this.welcomeModal.show();
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
    this.timeslotsSubscription$.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions$.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
    this.titleService.setPageTitle('seo.organizer.planning.planning.title');
  }

  public get logoHeight(): number {
    return this.isMobileDevice ? 30 : 45;
  }

  public getTimeslots(startDate: string, endDate: string, page = 1): void {
    const limit = 100;

    this.timeslots = [];

    this.timeslotsSubscription$ = this.organizerSharedActivityService
      .getTimeslotsByOrganizationId(
        this.organizerSharedOrganizationService?.organization?.identifier,
        {
          endDate,
          startDate,
          pagination: {
            from: (page - 1) * limit,
            limit,
          },
        }
      )
      .pipe(
        expand((timeslots) => {
          if (timeslots?.length >= limit) {
            page = page + 1;

            return this.organizerSharedActivityService.getTimeslotsByOrganizationId(
              this.organizerSharedOrganizationService?.organization?.identifier,
              {
                endDate,
                startDate,
                pagination: {
                  from: (page - 1) * limit,
                  limit,
                },
              }
            );
          }

          return EMPTY;
        }),
        concatMap((timeslots) => {
          return timeslots;
        }),
        reduce((accumulator, value) => {
          accumulator.push(value);
          return accumulator;
        }, [])
      )
      .subscribe((timeslots) => {
        this.timeslots = timeslots;
        this.activitySelectionService.setExistingTimeslots(this.timeslots);
      });
  }

  public updateDateRange({
    startDate,
    endDate,
  }: {
    startDate: string;
    endDate: string;
  }): void {
    this.getTimeslots(startDate, endDate);
  }
}
